// src/components/UIProviders.tsx
"use client";

import { usePathname } from "next/navigation";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v14-appRouter";
import MuiThemeProvider from "@/app/theme-provider";
import Navigation from "@/_components/Header/Navigation";
import Footer from "@/_components/Footer/Footer";
import { Toaster } from "react-hot-toast";

export function UIProviders({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isEmbed = pathname.startsWith("/embed");

  if (isEmbed) {
    return <>{children}</>;
  }

  return (
    <AppRouterCacheProvider>
      <MuiThemeProvider>
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>

        <Navigation />

        <main
          id="main-content"
          tabIndex={-1}
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </main>

        <Footer />

        <Toaster
          position="top-center"
          toastOptions={{
            style: { fontSize: "14px" },
            duration: 4000,
          }}
        />
      </MuiThemeProvider>
    </AppRouterCacheProvider>
  );
}
